import { render, staticRenderFns } from "./FinishedProductPhotosList.vue?vue&type=template&id=5b04e0aa&scoped=true&"
import script from "./FinishedProductPhotosList.vue?vue&type=script&lang=ts&"
export * from "./FinishedProductPhotosList.vue?vue&type=script&lang=ts&"
import style0 from "./FinishedProductPhotosList.vue?vue&type=style&index=0&id=5b04e0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04e0aa",
  null
  
)

export default component.exports